import script from "./TestModal1.vue?vue&type=script&setup=true&name=TestModal1&lang=js"
export * from "./TestModal1.vue?vue&type=script&setup=true&name=TestModal1&lang=js"

const __exports__ = script;

export default __exports__